
if ( window?.Nu?.notices ) {
    displayNotices();
}

export const NOTICE = 0;
export const SUCCESS = 1;
export const ERROR = 2;

export async function displayNotices() {
    while ( Nu.notices.length > 0 ) {
        await notify( Nu.notices.shift() );
    }
}

/**
 * @param {string} message
 * @param {0|1|2} type see NOTICE = 0, SUCCESS = 1, ERROR = 2
 *
 * @return {Promise<true>}
 */
export async function notify( message, type = NOTICE ) {
    return new Promise( ( resolve ) => {
        const notice = document.createElement( 'div' );
        notice.classList.add( 'nu-notice' );
        notice.textContent = message;

        if ( type === SUCCESS ) {
            notice.classList.add( 'nu-notice--success' );
        } else if ( type === ERROR ) {
            notice.classList.add( 'nu-notice--error' );
        }

        document.body.append( notice );

        notice.animate( {
            transform: ['translateY(calc(100% + 2rem))', 'translateY(0)']
        }, { duration: 1000, easing: 'ease' } );

        setTimeout( () => {
            const anim = notice.animate( {
                transform: ['translateY(0)', 'translateY(calc(100% + 2rem))']
            }, { duration: 1000, easing: 'ease' } );

            anim.addEventListener( 'finish', () => {
                notice.remove();
                resolve( true );
            } );
        }, 5000 );

    } );
}